import { pickBy, startCase, toLower, uniqBy } from 'lodash';
import moment from 'moment';
import { DATE_FORMAT, DAY_DATE_FORMAT, TIME_FORMAT, TIME_FORMAT_AM_PM } from './config';
export const toAsysnOption = (res) =>
	res?.rows?.map((x) => ({
		label: `${x.code || ''}: ${x.name || ''}`,
		value: x.id,
		brands:
			x?.Brands?.map((y) => ({
				label: `${y.code || ''}: ${y.name || ''}`,
				value: y.id,
			})) || [],
	})) || [];

/**
 *
 * underscore replace function
 */
export function unScReplace(str = '') {
	return startCase(toLower(str?.replace(/_/g, ' ')));
}

export function getFirstChar(str = '') {
	return str?.charAt(0);
}

export function getunique(sourceData, key) {
	return uniqBy(
		sourceData?.map((item) => ({
			text: unScReplace(item?.[key]),
			value: item?.[key],
		})),
		'value'
	);
}

// paginate Configs
export const initialPaginateConfig = {
	offset: 0,
	limit: 10,
	currentPage: 1,
	search_type: null,
};

export const initialPaginateConfigWithoutQ = {
	offset: 0,
	limit: 10,
	currentPage: 1,
};

// disable future date in datepicker
export function disableFutureDate(current) {
	// Can not select future days
	return current && current.valueOf() >= Date.now();
}

export function getPureParams(data = {}) {
	return pickBy(data, (x) => x === 0 || x);
}
export function getCapsTitle(data) {
	return data.toUpperCase();
}

export function getuniqueArray(array_data) {
	const jsonObject = array_data.map(JSON.stringify);
	const uniqueSet = new Set(jsonObject);
	return Array.from(uniqueSet).map(JSON.parse);
}

export function getServerFormatedDate(date, key_name) {
	if (!date) {
		return { fomatedDate: null, formatedTime: null };
	}

	const fomatedDate = moment.utc(date).format(DATE_FORMAT);
	const formatedTime = moment.utc(date).format(TIME_FORMAT);

	if (key_name === 'reporting_date') {
		return { reporting_date_payload: fomatedDate, reporting_time_payload: formatedTime };
	}
	if (key_name === 'start_date') {
		return { start_date_payload: fomatedDate, start_time_payload: formatedTime };
	}
	if (key_name === 'end_date') {
		return { end_date_payload: fomatedDate, end_time_payload: formatedTime };
	}

	return { fomatedDate, formatedTime };
}

// V2 version: Format date without UTC conversion (send time as-is)
export function getServerFormatedDateV2(date, key_name) {
	if (!date) {
		return { fomatedDate: null, formatedTime: null };
	}

	// Use moment() instead of moment.utc() to avoid UTC conversion
	const fomatedDate = moment(date).format(DATE_FORMAT);
	const formatedTime = moment(date).format(TIME_FORMAT);

	if (key_name === 'reporting_date') {
		return { reporting_date_payload: fomatedDate, reporting_time_payload: formatedTime };
	}
	if (key_name === 'start_date') {
		return { start_date_payload: fomatedDate, start_time_payload: formatedTime };
	}
	if (key_name === 'end_date') {
		return { end_date_payload: fomatedDate, end_time_payload: formatedTime };
	}

	return { fomatedDate, formatedTime };
}

export function getFormatedDayDateAndTime(date, key_name) {
	if (!date) {
		return { fomatedDate: null, formatedTime: null, formatedTimeAMPM: null };
	}

	const fomatedDate = moment.utc(date).format(DAY_DATE_FORMAT);
	const formatedTime = moment.utc(date).format(TIME_FORMAT);
	const formatedTimeAMPM = moment.utc(date).format(TIME_FORMAT_AM_PM);

	if (key_name === 'reporting_date') {
		return {
			reporting_date_payload: fomatedDate,
			reporting_time_payload: formatedTime,
			reporting_time_payload_ampm: formatedTimeAMPM,
		};
	}
	if (key_name === 'start_date') {
		return {
			start_date_payload: fomatedDate,
			start_time_payload: formatedTime,
			start_time_payload_ampm: formatedTimeAMPM,
		};
	}
	if (key_name === 'end_date') {
		return {
			end_date_payload: fomatedDate,
			end_time_payload: formatedTime,
			end_time_payload_ampm: formatedTimeAMPM,
		};
	}

	return { fomatedDate, formatedTime, formatedTimeAMPM };
}

export function checkForNullDate(time) {
	console.log(time);
	console.log(moment(time).add(330, 'minutes'));

	if (time) {
		return moment.utc(time, 'MM/DD/YYYY HH:mm').toDate();
	}
	return '';
}

export function getLocalDate(date) {
	if (date) {
		return moment(date).format(DAY_DATE_FORMAT);
	}
	return '';
}

export function getLocalTime(time) {
	if (time) {
		return moment(time).add(330, 'minutes').format(TIME_FORMAT_AM_PM);
	}
	return '';
}

export function getweekOffValue(monthwise_option, week_off, default_value) {
	console.log(monthwise_option, week_off, default_value);
	if (monthwise_option === 'week_off' && week_off.length > 0) {
		return default_value;
	}
	return default_value;
}

export function getSelectedMonthWise(data) {
	if (data) {
		const monthKeys = [];
		Object.entries(data).forEach(([key, value]) => {
			if (value) {
				monthKeys.push(key);
			}
		});
		console.log('monthKeys', monthKeys);
		return monthKeys;
	}
	return [];
}
